module.exports = __webpack_public_path__ + "img/nightstalker.6c5419d4.webp";